import React, { type FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { ArrowDown } from '@gravity-ui/icons';
import { Button, Icon, ThemeProvider } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import clx from 'classnames';
import { HeaderQuickApps } from 'client/blocks/Header/Header';
import { routes } from 'client/lib/routes';
import * as keyset from 'i18n/PrivateApps';

import { QuickAppSmartScreenLabel, QuickAppTvLabel } from '../labels/QuickAppsLabels';

import styles from './QuickAppsStartPage.module.scss';

const t = i18n(keyset);

const bgPicture = `${__appConfig.app.staticResourcesUrl}/dialogs/dev-console/images/quick-apps-violet-abstract-bg.webp`;

export const QuickAppsStartPage: FC = () => {
    const navigate = useNavigate();
    const isMaintenance = __appConfig.app.quickAppsMaintenance;

    const onMainPageNavigate = () => {
        navigate(routes.app.quickApps());
    };

    return (
        <ThemeProvider theme="dark" scoped>
            <div className={styles.quickAppsStartPage__container}>
                <div className={styles.quickAppsStartPage__paddedBackground} />
                <div
                    className={clx(styles.quickAppsStartPage__image, {
                        [styles.quickAppsStartPage__image_maintenance]: isMaintenance,
                    })}
                    style={{ backgroundImage: `url(${bgPicture})` }}
                />
                <HeaderQuickApps startPage />
                <section className={styles.quickAppsStartPage__wrapper}>
                    <div
                        className={clx(styles.quickAppsStartPage__content, {
                            [styles.quickAppsStartPage__content_maintenance]: isMaintenance,
                        })}
                    >
                        <h1 className={styles.quickAppsStartPage__header}>
                            {t(isMaintenance ? 'maintenance-title' : 'install-android-apps')}
                        </h1>
                        {isMaintenance ? (
                            <>
                                <p className={styles.quickAppsStartPage__description}>{t('maintenance-description')}</p>
                                <p className={styles.quickAppsStartPage__description}>
                                    {t('maintenance-reassurance')}
                                    <br />
                                    {t('maintenance-thanks')}
                                </p>
                                <img
                                    className={styles.quickAppsStartPage__maintenanceLogo}
                                    src={routes.app.assets('images/quick-apps-maintenance-logo.png')}
                                    width={233}
                                    height={140}
                                    alt=""
                                />
                            </>
                        ) : (
                            <>
                                <div className={styles.quickAppsStartPage__labels}>
                                    <QuickAppTvLabel />
                                    <QuickAppSmartScreenLabel />
                                </div>
                                <p className={styles.quickAppsStartPage__description}>{t('upload-apk-files')}</p>
                                <Button
                                    onClick={onMainPageNavigate}
                                    className={styles.quickAppsStartPage__actionButton}
                                    size="xl"
                                    view="action"
                                >
                                    <Icon data={ArrowDown} />
                                    {t('upload-apps')}
                                </Button>
                            </>
                        )}
                    </div>
                </section>
            </div>
        </ThemeProvider>
    );
};
